export default "__VITE_ASSET__CPI7eyfZ__"